(function ($) {
    'use strict';

    var $ctr = $('#main-header'),
        $nav = $('#site-nav'),
        $tabs = $nav.find('>li'),
        lastBottom = $ctr[0].getBoundingClientRect().bottom,
        bufferHeight = 60, // minimum is the abs of top for #main-header.offscreen .sticky-header in css
        afterScrollQueue = [],
        lastIsOff, lastIsSticky, transitionTimeout, scrollTimeout;

    function isInNav($elt) {
        return $elt.closest($nav).length > 0;
    }

    function isInTab($elt, $tab) {
        return $elt.closest($tab).length > 0;
    }

    function tempDisableTransitions() {
        $ctr.addClass('no-transition');
        if (!transitionTimeout) {
            transitionTimeout = window.setTimeout(function () {
                $ctr.removeClass('no-transition');
                transitionTimeout = 0;
            }, 100);
        }
    }

    // Sticky header
    $(window).on('DOMContentLoaded load resize scroll', function () {
        var bottom = $ctr[0].getBoundingClientRect().bottom,
            isScrollingUp = bottom >= lastBottom, // true asc, false desc
            isOff = bottom <= 0,
            isSticky = isScrollingUp ? bottom <= (-1 * bufferHeight) : isOff, //bottom <= -15,
            offChanged = isOff !== lastIsOff,
            stickyChanged = isSticky !== lastIsSticky;
        lastIsOff = isOff;
        lastIsSticky = isSticky;
        lastBottom = bottom;
        function setClass(cond, className) {
            $ctr[cond ? 'addClass' : 'removeClass'](className);
        }
        if (offChanged || stickyChanged) {
            tempDisableTransitions();
            if (offChanged) {
                setClass(isOff, 'offscreen');
            }
            if (stickyChanged) {
                if (isScrollingUp) {
                    setClass(isSticky, 'sticky');
                } else {
                    afterScrollQueue.push(function () { setClass(isSticky, 'sticky'); });
                }
            }
        }
    }).on('scroll', function () {
        if (!scrollTimeout && afterScrollQueue.length > 0) {
            scrollTimeout = window.setTimeout(function () {
                var f = afterScrollQueue.shift();
                while (typeof f === 'function') {
                    f();
                    f = afterScrollQueue.shift();
                }
                scrollTimeout = 0;
            }, 250);
        }
    }).on('resize', function () {
        $ctr.removeClass('nst');
    });

    // Keyboard access for mega menu
    $('a', $nav).on('focus', function () {
        var $active = $(this);
        $ctr.addClass('no-transition');
        $tabs.each(function () {
            var $tab = $(this);
            $tab[isInTab($active, $tab) ? 'addClass' : 'removeClass']('focused');
        });
    }).on('blur', function () {
        window.setTimeout(function () {
            if (!isInNav($(document.activeElement))) {
                $('.focused', $nav).removeClass('focused');
                window.setTimeout(function () {
                    $ctr.removeClass('no-transition');
                }, 10);
            }
        }, 10);
    });

    // Account for combined use of they keyboard and mouse on the mega menu
    $nav.on('mouseover', function () {
        var $active = $(document.activeElement);
        if (isInNav($active)) {
            window.setTimeout(function () {
                $active.blur();
            }, 10);
        }
    });

})(window.jQuery);
